export const getEsignAnalysesData = state => state.esignAnalyses.all;
export const getEsignAnalysisData = state => state.esignAnalyses.esignAnalysis;
export const esignAnalysesIsFetching = state => state.esignAnalyses.loading.all;
export const esignAnalysisIsFetching = state => state.esignAnalyses.loading.esignAnalysis;
